import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const wpBlockGroup = () => {
    const groupSliders = document.querySelectorAll('.wp-block-group.is-slider');

    if (!groupSliders.length) return;

    groupSliders.forEach(slider => {
        // add swiper root class to slider


        let autoplay = false;
        if (slider.classList.contains('is-autoplay')) {
            autoplay = {
                delay: 5000,
                disableOnInteraction: true,
            };
        }
        let loop = false;
        if (slider.classList.contains('is-loop')) {
            loop = true;
        }
        slider.classList.add('swiper');

        // wrap existing content in swiper-wrapper
        const existingMarkup = slider.innerHTML;
        slider.innerHTML = `<div class=\"swiper-wrapper\">${existingMarkup}</div>`;

        // wrap each direct child of the group as a swiper-slide
        const wrapper = slider.querySelector('.swiper-wrapper');
        if (wrapper && !wrapper.querySelector(':scope > .swiper-slide')) {
            const children = Array.from(wrapper.children);
            children.forEach(child => {
                const slide = document.createElement('div');
                slide.className = 'swiper-slide';
                slide.appendChild(child);
                wrapper.appendChild(slide);
            });
        }

        // create navigation and pagination elements
        const prevEl = document.createElement('a');
        prevEl.href = '#';
        prevEl.className = 'swiper-button-prev';
        prevEl.setAttribute('aria-label', 'Previous slide');

        const nextEl = document.createElement('a');
        nextEl.href = '#';
        nextEl.className = 'swiper-button-next';
        nextEl.setAttribute('aria-label', 'Next slide');

        const paginationEl = document.createElement('div');
        paginationEl.className = 'swiper-pagination';

        // append controls to the slider
        slider.appendChild(prevEl);
        slider.appendChild(nextEl);
        slider.appendChild(paginationEl);

        // initialize swiper on this slider instance
        const swiper = new Swiper(slider, {
            spaceBetween: 32,
            loop: loop,
            autoplay: autoplay,
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            navigation: {
                nextEl,
                prevEl,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
            },
        });
    });
}